import {useMemo} from 'react';
import {ObjectSchema, AnyObject, SchemaObjectDescription, SchemaDescription} from 'yup';

export const useRequiredFields = <T extends AnyObject>(
  schema: ObjectSchema<T>,
): (keyof T)[] => {
  return useMemo(() => {
    if (!schema || typeof schema.describe !== 'function'){ return []; }

    const description: SchemaObjectDescription = schema.describe();
    const fields = description.fields;
    return Object.keys(fields).filter(key => {
        const field = fields[key] as SchemaDescription;
        return  field.tests.some((test) => test.name === 'required');
    }) as (keyof T)[];
  }, [schema]);
};
